import React from 'react';
import { getCurrentUser } from 'Modules/AAA/selectors';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { mediaSmDown } from 'theme/helpers/css';
import { colors } from 'constants/colors';

const Caption = styled.span`
  margin-right: 6px;

  ${mediaSmDown`
    margin-right: 10px;
  `}
`;

const Quantity = styled.span`
  color: ${colors.pinkishGrey};
`;

interface IPointsTabProps {
  caption: string | JSX.Element;
}

const PointsTab: React.FC<IPointsTabProps> = ({ caption }: IPointsTabProps) => {
  const { points } = useSelector(getCurrentUser);

  return (
    <>
      <Caption>{caption}</Caption>
      <Quantity>{points}</Quantity>
    </>
  );
};

export default React.memo(PointsTab);
